import { render, staticRenderFns } from "./ModalCriarProduto.vue?vue&type=template&id=3f4094c7&"
import script from "./ModalCriarProduto.vue?vue&type=script&lang=js&"
export * from "./ModalCriarProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports